import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import UserService from 'services/UserService.js';
import Utils from 'utils/Utils.js';

import {initNavbarState} from 'actions/navbar.js';
import Satisfaction from './Satisfaction.js';

class SatisfactionContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {rating:null, error:null, busy:false, complete:false};
        this.onSave = this.onSave.bind(this);
        this.onSkip = this.onSkip.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    
    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, title:'Satisfaction', mode:'light'}));
    }

    onSave() {
        this.setState({busy:true});
        UserService.updateProfile({userProfile:{ satisfactionRating : this.state.rating }})
            .then(() => {
                this.setState({complete:true});
                Utils.delay(1000).then(()=>{
                    this.props.next();
                })
            },() => {
                this.setState({error:"Oops! We couldn't save your satisfaction rating. Please try again."});
            }).then(()=>{//always
                this.setState({busy:false});
            })
    }

    onSkip() {
        this.props.next();
    }

    onChange(value) {
        this.setState({rating:value});
    }
    

    render() {
        return <Satisfaction rating={this.state.rating}
                             onSave={this.onSave}
                             onSkip={this.onSkip}
                             onChange={this.onChange}
                             error={this.state.error}
                             busy={this.state.busy}
                             complete={this.state.complete} />;
    }

}



export default connect()(translate('onboarding')(SatisfactionContainer));



// WEBPACK FOOTER //
// ./src/modules/onboarding/SatisfactionContainer.js